import React, { useEffect } from "react";
import SolutionForm from "./SolutionForm";
import { useSolution } from "../../../contexts/SolutionsContext";
import "../css/register.sol.css";
import { useLocation } from "react-router-dom";

const RegisterSolution = () => {
  const {
    clearOngoingSolutionData,
    fetchAgents,
    fetchSolutionBFs,
    fetchSolutionProviders,
    fetchSolutionIndustries,
  } = useSolution();
  const location = useLocation();

  useEffect(() => {
    clearOngoingSolutionData();

    Promise.allSettled([
      fetchAgents(),
      fetchSolutionBFs(),
      fetchSolutionProviders(),
      fetchSolutionIndustries(),
    ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  return <SolutionForm type="register" />;
};

export default RegisterSolution;
